import React, { useState, useEffect, useContext } from "react";
import { AppContext } from "../../context/AppContext";
import axios from "axios";
import { Outlet, useNavigate } from "react-router-dom";
import "./Css/GameSidebar.css"; // Adjust the path as necessary
const GameSidebar = ({
  addclass = "sidebar sidebar_mobile",
  sidebarimg = "sidebar-img",
  position,
  limitgamefrom = 0,
  limitgameto = 4,
}) => {
  const {
    categories,
    baseUrl,
    addGameUrl,
    addThumbImg,
    setdescreption,
    setgametitle,
    setmetadata,
    gametype,
    gameId,
    setGameIframe,
    setGameIframeStatus,
    setappstorelink,
    AppStoreLink,
    setThumbImgStatus,
    setgameid,
  } = useContext(AppContext);
  const navigate = useNavigate();
  const [categoryWiseGames, setCategoryWiseGames] = useState();
  const Backend_folder_path = "https://htmlgames4u.com";
  const [gameTitle, setgameTitle] = useState("");

  const fetchCategoryGames = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/getgame-categorywise/${categories}`
      );
      console.log("Category Games Response:", response.data);
      let gamedata = response.data.data.filter(
        (game) => game.gameType == gametype && game.id != gameId
      );
      //get games from casual categories if there is no match type game
      const mergedGames = [...gamedata, ...response.data.casualGames];
      if (gamedata.length < 4) {
        setCategoryWiseGames(mergedGames);
      } else {
        setCategoryWiseGames(gamedata);
      }

      sessionStorage.setItem(
        "relatedGameList",
        JSON.stringify(response.data.data)
      );
    } catch (err) {
      //console.error('Error fetching games:', err);
    } finally {
    }
  };
  useEffect(() => {
    const gameCurrentGameTitle = window.location.pathname.split("/").pop();
    setgameTitle(gameCurrentGameTitle);

    if (!categories) return; // Skip if no category

    fetchCategoryGames();
  }, [categories]);
  const setgame = (game) => {
    addGameUrl(`${Backend_folder_path}${game.folder_path}/index.html`);
    addThumbImg(`${Backend_folder_path}${game.thumbnail_img_path}`);
    const titleTag = document.querySelector("head > title");
    titleTag.textContent = game.meta_title;
    navigate(`/game/${game.url}`);
    setTimeout(() => {
      window.scrollTo({ top: "59", behavior: "smooth" });
    }, 100);
  };
  return (
    <div className={`${addclass}  ${position}`}>
      {categoryWiseGames &&
        categoryWiseGames.slice(Number(limitgamefrom), Number(limitgameto)).map(
          (game, idx) =>
            game.game_title !== gameTitle &&
            game.enable && (
              <div
                style={{ cursor: "pointer" }}
                className={`${sidebarimg}`}
                key={idx}
              >
                <img
                  style={{ width: "120px", height: "115px" }}
                  src={`${Backend_folder_path}${game.thumbnail_img_path}`}
                  onClick={() => {
                    setgameid(game.id);
                    setGameIframeStatus(false);
                    setThumbImgStatus(true);
                    setgame(game);
                    setdescreption(game.description);
                    setgametitle(game.game_title);
                    setmetadata({
                      title: game.meta_title,
                      keywords: game.meta_keyword,
                      descreption: game.meta_description,
                    });
                    setappstorelink({
                      ...AppStoreLink,
                      iso_link: game.iso_link,
                      playstore_link: game.playstore_link,
                    });
                    const titleTag = document.querySelector("head > title");
                    titleTag.textContent = game.game_title
                      .replace(/-/g, " ")
                      .replace(/\b\w/g, (char) => char.toUpperCase());
                    navigate(`/game/${game.url}`);
                  }}
                  alt={`Game ${idx}`}
                />
                {/* <p>{game.name}</p> */}
                <div className="hover-title">{game.game_title}</div>
              </div>
            )
        )}
    </div>
  );
};

export default GameSidebar;
